// Forked from api/msw/api/caseTypes/mockData.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { IServiceRequestType } from '~/types/serviceRequest/models'

export async function getStartingServiceRequestTypeListData(): Promise<
  IServiceRequestType[]
> {
  // Not the case types: Service Requests are moves, adds, changes and
  // disconnects ("Service Down" stays a case type only). SRT0002 keeps the id
  // and label it was forked with.
  return [
    {
      id: 'XXSRT0001',
      hrid: 'SRT0001',
      canBeDeleted: true,
      descr: 'Move',
    },
    {
      id: 'XXSRT0002',
      hrid: 'SRT0002',
      canBeDeleted: true,
      descr: 'Address Change',
    },
    {
      id: 'XXSRT0003',
      hrid: 'SRT0003',
      canBeDeleted: true,
      descr: 'Add',
    },
    {
      id: 'XXSRT0004',
      hrid: 'SRT0004',
      canBeDeleted: true,
      descr: 'Change',
    },
    {
      id: 'XXSRT0005',
      hrid: 'SRT0005',
      canBeDeleted: true,
      descr: 'Disconnect',
    },
  ]
}
